export default class FetchedSubject {
  slug: string
  updated: number

  constructor(slug: string, updated: any) {
    this.slug = slug;
    this.updated = updated;
  }
}
